/* ============================================================
   ALOR Product Page — product-page.js
   ============================================================ */

(function () {
  'use strict';

  /* ── STATE ── */
  let alorQtyValue = 1;
  let alorSelectedOptions = {};
  let alorCurrentIndex = 0;

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
    alorInitOptions();
    alorEnforceSquare();
    alorInitSwipe();
    document.querySelectorAll('.alor-rn').forEach(function(el) {
      el.textContent = el.textContent.replace(/^ALOR\s*/i, '');
    });
  });

  /* ─────────────────────────────────────────────
     SQUARE BUTTON ENFORCEMENT
  ───────────────────────────────────────────── */
  function alorEnforceSquare() {
    document.querySelectorAll('.alor-product button').forEach(function (el) {
      el.style.setProperty('border-radius', '0', 'important');
    });
  }
  window.alorEnforceSquare = alorEnforceSquare;

  /* ─────────────────────────────────────────────
     IMAGE GALLERY
  ───────────────────────────────────────────── */
  window.alorSetMedia = function (index) {
    alorCurrentIndex = index;

    /* Update thumbnails */
    document.querySelectorAll('.alor-thumb').forEach(function (el, i) {
      el.classList.toggle('active', i === index);
    });

    /* Update dots */
    document.querySelectorAll('.alor-idot').forEach(function (el, i) {
      el.classList.toggle('active', i === index);
    });

    var slides = document.querySelectorAll('.alor-media-slide');

    if (window.innerWidth <= 999) {
      /* Mobile: carousel — show only active slide */
      slides.forEach(function (slide, i) {
        slide.classList.toggle('active', i === index);
      });
    } else {
      /* Desktop: scroll to slide */
      var target = slides[index];
      if (target && !target.classList.contains('color-hidden')) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  /* ─────────────────────────────────────────────
     SWIPE SUPPORT (mobile only)
  ───────────────────────────────────────────── */
  function alorInitSwipe() {
    var gallery = document.getElementById('alor-mimg');
    if (!gallery) return;

    var startX = 0;
    var threshold = 40;

    gallery.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', function (e) {
      if (window.innerWidth > 999) return;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < threshold) return;

      /* Get visible slides only */
      var allSlides = Array.from(document.querySelectorAll('.alor-media-slide'));
      var visibleSlides = allSlides.filter(function (s) {
        return s.style.display !== 'none';
      });

      var currentVisiblePos = visibleSlides.findIndex(function (s) {
        return allSlides.indexOf(s) === alorCurrentIndex;
      });

      if (diff > 0 && currentVisiblePos < visibleSlides.length - 1) {
        /* Swipe left → next */
        var nextSlide = visibleSlides[currentVisiblePos + 1];
        alorSetMedia(allSlides.indexOf(nextSlide));
      } else if (diff < 0 && currentVisiblePos > 0) {
        /* Swipe right → previous */
        var prevSlide = visibleSlides[currentVisiblePos - 1];
        alorSetMedia(allSlides.indexOf(prevSlide));
      }
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────
     VARIANT OPTION SELECTION
  ───────────────────────────────────────────── */
  function alorInitOptions() {
    if (!window.alorProduct) return;
    document.querySelectorAll('.alor-sw.active, .alor-sz.active').forEach(function (el) {
      var idx = parseInt(el.dataset.optionIndex, 10);
      alorSelectedOptions[idx] = el.dataset.value;
    });
    alorUpdateVariant();
  }

  /* ─────────────────────────────────────────────
     COLOR SWATCH
  ───────────────────────────────────────────── */
  window.alorPickColor = function (row) {
    var value = row.dataset.value;
    var optionIndex = parseInt(row.dataset.optionIndex, 10);

    var floatLabel = document.getElementById('alor-color-label-float');
    if (floatLabel) floatLabel.textContent = value;

    var container = row.parentElement;
    container.querySelectorAll('.alor-sw-row').forEach(function (r) {
      r.classList.remove('active');
      var sw = r.querySelector('.alor-sw');
      if (sw) sw.classList.remove('active');
    });
    row.classList.add('active');
    var thisSw = row.querySelector('.alor-sw');
    if (thisSw) thisSw.classList.add('active');

    var colorLower = value.toLowerCase();
    var slides = document.querySelectorAll('.alor-media-slide');
    var thumbs = document.querySelectorAll('.alor-thumb');
    var dots = document.querySelectorAll('.alor-idot');
    var matchingIndices = [];

    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      var altText = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
      if (altText.indexOf(colorLower) !== -1) matchingIndices.push(i);
    });

    if (matchingIndices.length === 0) {
      slides.forEach(function (s) { s.style.display = ''; });
      thumbs.forEach(function (t) { t.style.display = ''; });
      dots.forEach(function (d) { d.style.display = ''; });
      alorSetMedia(0);
    } else {
      slides.forEach(function (slide, i) {
        slide.style.display = matchingIndices.indexOf(i) !== -1 ? '' : 'none';
      });
      thumbs.forEach(function (thumb, i) {
        thumb.style.display = matchingIndices.indexOf(i) !== -1 ? '' : 'none';
      });
      dots.forEach(function (dot, i) {
        dot.style.display = matchingIndices.indexOf(i) !== -1 ? '' : 'none';
      });
      alorSetMedia(matchingIndices[0]);
    }

    alorPickOption(thisSw, 'color');
  };

  window.alorPickOption = function (el, type) {
    var optionIndex = parseInt(el.dataset.optionIndex, 10);
    var value = el.dataset.value;

    var siblings = document.querySelectorAll('[data-option-index="' + optionIndex + '"]');
    siblings.forEach(function (s) { s.classList.remove('active'); });
    el.classList.add('active');

    var labelId = type === 'color' ? 'alor-color-label' : 'alor-size-label';
    if (type !== 'color' && type !== 'size') labelId = 'alor-' + type + '-label';
    var label = document.getElementById(labelId);
    if (label) label.textContent = value;

    alorSelectedOptions[optionIndex] = value;
    alorUpdateVariant();
    alorEnforceSquare();
  };

function alorUpdateVariant() {
    if (!window.alorProduct) return;
    var variants = window.alorProduct.variants;
    var numOptions = window.alorProduct.options.length;

    // Only match if ALL options are selected
    var allSelected = true;
    for (var i = 0; i < numOptions; i++) {
      if (!alorSelectedOptions[i]) { allSelected = false; break; }
    }

    var variantInput = document.getElementById('alor-variant-id');

    if (!allSelected) {
      if (variantInput) variantInput.value = '';
      var cartBtn = document.getElementById('alor-add-to-cart');
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.textContent = 'Select options';
        cartBtn.style.opacity = '0.4';
        cartBtn.style.cursor = 'not-allowed';
      }
      return;
    }

    var matched = variants.find(function (v) {
      for (var i = 0; i < numOptions; i++) {
        if (v['option' + (i + 1)] !== alorSelectedOptions[i]) return false;
      }
      return true;
    });

    if (!matched) {
      if (variantInput) variantInput.value = '';
      return;
    }

    if (variantInput) variantInput.value = matched.id;

    var priceEl = document.getElementById('alor-price');
    if (priceEl && matched.price) {
      var formatted = alorFormatMoney(matched.price);
      var compareFormatted = matched.compare_at_price
        ? '<span class="alor-price-compare">' + alorFormatMoney(matched.compare_at_price) + '</span>'
        : '';
      priceEl.innerHTML = compareFormatted + '<span class="alor-price-current">' + formatted + '</span>';
    }

    var cartBtn = document.getElementById('alor-add-to-cart');
    if (cartBtn) {
      cartBtn.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
      cartBtn.disabled = !matched.available;
      cartBtn.style.opacity = matched.available ? '' : '0.4';
      cartBtn.style.cursor = matched.available ? '' : 'not-allowed';
      cartBtn.style.setProperty('border-radius', '0', 'important');
    }

    if (matched.featured_media && matched.featured_media.position) {
      alorSetMedia(matched.featured_media.position - 1);
    }

    alorMarkUnavailable();
  }
  
  function alorMarkUnavailable() {
    if (!window.alorProduct) return;
    document.querySelectorAll('.alor-sizes .alor-sz').forEach(function (btn) {
      var sizeOptIdx = parseInt(btn.dataset.optionIndex, 10);
      var sizeValue = btn.dataset.value;
      var hasAvailable = window.alorProduct.variants.some(function (v) {
        if (v['option' + (sizeOptIdx + 1)] !== sizeValue) return false;
        for (var i = 0; i < window.alorProduct.options.length; i++) {
          if (i === sizeOptIdx) continue;
          if (alorSelectedOptions[i] && v['option' + (i + 1)] !== alorSelectedOptions[i]) return false;
        }
        return v.available;
      });
      btn.classList.toggle('unavailable', !hasAvailable);
    });
  }

  /* ─────────────────────────────────────────────
     MONEY FORMATTING
  ───────────────────────────────────────────── */
  function alorFormatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + parseFloat(dollars).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* ─────────────────────────────────────────────
     QUANTITY
  ───────────────────────────────────────────── */
  window.alorQty = function (delta) {
    alorQtyValue = Math.max(1, alorQtyValue + delta);
    var display = document.getElementById('alor-qty-display');
    var input = document.getElementById('alor-qty-input');
    if (display) display.textContent = alorQtyValue;
    if (input) input.value = alorQtyValue;
  };

  /* ─────────────────────────────────────────────
     TABS
  ───────────────────────────────────────────── */
  window.alorTab = function (btn, id) {
    document.querySelectorAll('.alor-th').forEach(function (b) { b.classList.remove('active'); });
    document.querySelectorAll('.alor-tab-body').forEach(function (c) { c.classList.remove('active'); });
    btn.classList.add('active');
    var panel = document.getElementById(id);
    if (panel) panel.classList.add('active');
    alorEnforceSquare();
  };

  /* ─────────────────────────────────────────────
     ACCORDION
  ───────────────────────────────────────────── */
  window.alorAccord = function (btn) {
    var body = btn.nextElementSibling;
    var icon = btn.querySelector('.alor-aico');
    var isOpen = body.classList.contains('open');
    body.classList.toggle('open', !isOpen);
    icon.classList.toggle('open', !isOpen);
    alorEnforceSquare();
  };

  /* ─────────────────────────────────────────────
     WISHLIST
  ───────────────────────────────────────────── */
  window.alorWishlist = function (btn) {
    if (!window.alorProduct) return;
    var productId = window.alorProduct.id;
    var variantId = document.getElementById('alor-variant-id')
      ? document.getElementById('alor-variant-id').value : null;
    var isWishlisted = btn.classList.contains('wishlisted');

    if (isWishlisted) {
      btn.classList.remove('wishlisted');
      btn.textContent = 'Save to Wishlist';
      alorWishlistRemove(productId);
    } else {
      btn.classList.add('wishlisted');
      btn.textContent = '✓ Saved to Wishlist';
      alorWishlistAdd(productId, variantId);
    }

    btn.style.setProperty('border-radius', '0', 'important');
    document.dispatchEvent(new CustomEvent('alor:wishlist:toggle', {
      detail: { productId: productId, variantId: variantId, wishlisted: !isWishlisted }
    }));
  };

  function alorWishlistAdd(productId, variantId) {
    try {
      var list = JSON.parse(localStorage.getItem('alor-wishlist') || '[]');
      if (!list.includes(productId)) list.push(productId);
      localStorage.setItem('alor-wishlist', JSON.stringify(list));
    } catch (e) {}
  }

  function alorWishlistRemove(productId) {
    try {
      var list = JSON.parse(localStorage.getItem('alor-wishlist') || '[]');
      list = list.filter(function (id) { return id !== productId; });
      localStorage.setItem('alor-wishlist', JSON.stringify(list));
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.alorProduct) return;
    try {
      var list = JSON.parse(localStorage.getItem('alor-wishlist') || '[]');
      if (list.includes(window.alorProduct.id)) {
        var btn = document.querySelector('.alor-bwish');
        if (btn) {
          btn.classList.add('wishlisted');
          btn.textContent = '✓ Saved to Wishlist';
        }
      }
    } catch (e) {}
  });

})();